<template>
    <ContentOrLoading>
        <MainContentSearchable v-if="!loading" title="Listado de zonas" id="zonas" v-model="filters" :meta="loading ? {} : zonas.meta" @updated="debouncedGetZonas">
            <template v-slot:header>
                <h4>Listado para descargar en formato de pegatina las butacas vendidas en las zonas</h4>
            </template>
            <template v-slot:extra-options></template>
            <template v-slot:content>
                <div v-if="!error" :class="['table', { 'expanded': zonas.data.length <= 3 }]">
                    <b-table hover :items="zonas.data" :fields="fields" id="abonados-table">
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent 
                                :lastIndex="zonas.data.length > 3 && index >= zonas.data.length - 3"
                                v-bind:options="[
                                    { type: 'url', url: config.API_BASE + item.url_imprimir, label: 'Imprimir pegatinas'},
                                ]"
                            />
                        </template>
                    </b-table>
                </div>
                <div v-else class="alert alert-danger">
                    {{ error }}
                </div>
            </template>
        </MainContentSearchable>
    </ContentOrLoading>
</template>

<script>
import MainContentSearchable from "@/components/backend/components/MainContentSearchable";
import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";

export default {
    props: ['evento_id', 'sesion_id'],
    data() {
        return {
            zonas: { data: [], meta: { current_page: 1 } },
            loading: false,
            filters: {
                per_page: 10,
                page: 1,
                search: ''
            },
            fields: [
                { key: "id", label: "ID"},
                { key: "name", label: "Nombre" },
                { key: "opciones", label: "Opciones", class: 'text-center' }
            ],
            error: null
        }
    },
    methods: {
        getZonas() {
            this.loading = true;

            const params = {
                filters: this.filters,
                evento_id: this.evento_id,
                sesion_id: this.sesion_id,
                teatro_id: this.teatro.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.event.sesion.regiones'), params).then(res => {
                this.zonas = res.data;
            }).catch(error => {
                this.error = error.response.data.message;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.getZonas();
        this.debouncedGetZonas = _.debounce(this.getZonas, 500);
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    components: {
        MainContentSearchable, OpcionesDropdownTableComponent

    }
}
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>